/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".required[_ngcontent-%COMP%]{color:red!important}.primary-background[_ngcontent-%COMP%]{background-color:var(--primary-color)!important;border-color:var(--primary-color)!important}h2.calcuationstep[_ngcontent-%COMP%]{border-bottom:1px solid #22425b;border-top:1px solid #22425b;text-align:center;padding:20px 0;margin:0 0 20px}.cal-imp[_ngcontent-%COMP%]{font-weight:700}@media (min-width:400px){.m-cancel1[_ngcontent-%COMP%]{display:none!important}.m-cancel[_ngcontent-%COMP%]{display:block!important}}"];
export { styles as styles };
